import { Stack, styled } from '@mui/material';
import React from 'react';

const StyledLoader = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 'calc(50% - 128px)',
  left: 'calc(50% - 128px)',
  width: 256,
  height: 256,
  borderRadius: '50%',
  perspective: '800px',

  '& .inner': {
    position: 'absolute',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    borderRadius: '50%',

    '&.one': {
      left: 0,
      top: 0,
      animation: 'rotate-one 1s linear infinite',
      borderBottom: `3px solid ${theme.palette.secondary.main}`,
    },
    '&.two': {
      left: 0,
      top: 0,
      animation: 'rotate-two 1s linear infinite',
      borderRight: `3px solid ${theme.palette.secondary.main}`,
    },
    '&.three': {
      left: 0,
      top: 0,
      animation: 'rotate-three 1s linear infinite',
      borderRight: `3px solid ${theme.palette.secondary.main}`,
    },
  },

  '@keyframes rotate-one': {
    '0%': {
      transform: 'rotateX(35deg) rotateY(-45deg) rotateZ(0deg)',
    },
    '100%': {
      transform: 'rotateX(35deg) rotateY(-45deg) rotateZ(360deg)',
    },
  },

  '@keyframes rotate-two': {
    '0%': {
      transform: 'rotateX(50deg) rotateY(10deg) rotateZ(0deg)',
    },
    '100%': {
      transform: 'rotateX(50deg) rotateY(10deg) rotateZ(360deg)',
    },
  },

  '@keyframes rotate-three': {
    '0%': {
      transform: 'rotateX(35deg) rotateY(55deg) rotateZ(0deg)',
    },
    '100%': {
      transform: 'rotateX(35deg) rotateY(55deg) rotateZ(360deg)',
    },
  },
}));

function Loading() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%">
      <StyledLoader>
        <div className="inner one" />
        <div className="inner two" />
        <div className="inner three" />
      </StyledLoader>
    </Stack>
  );
}

export default Loading;
